<div class="lum-modal sales-order-update-status-form-dialog__modal-wrapper">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">{{ data.title }}</span>
  </div>
  <form [formGroup]="form" (submit)="onSubmit()">
    <div class="sales-order-update-status-form__wrapper">
      <div class="lum-modal__body">
        <div class="row">
          <div class="col">
            <div class="form-group" *ngIf="source !== 'picklist'">
              <div class="lum-label">Select Status</div>
              <mat-select class="lum-select" formControlName="orderStatus">
                <mat-option
                  *ngFor="let status of statusValues; trackBy: trackByValue"
                  [value]="status"
                >
                  {{ status }}
                </mat-option>
              </mat-select>
            </div>

            <ng-container
              *ngIf="
                form.get('orderStatus')?.value ===
                  salesOrderStatus.SHIPPED.toUpperCase() && !hideAdditionalFields
              "
            >
              <div class="form-group">
                <mat-label>Tracking Number</mat-label>
                <input
                  class="lum-input"
                  formControlName="trackingNumber"
                  placeholder="Tracking Number (Optional)"
                />
              </div>
              <div class="form-group">
                <mat-label>Carrier Code</mat-label>
                <input
                  class="lum-input"
                  formControlName="carrierCode"
                  placeholder="Carrier Code (Optional)"
                />
              </div>
            </ng-container>
          </div>
        </div>
        <div class="lum-modal__footer">
          <div class="flex ml-auto lum-modal__action">
            <button
              type="button"
              class="lum-button lum-button--secondary mr-2"
              mat-button
              (click)="onClose()"
            >
              Cancel
              <lum-ui-icon
                icon="close-circle"
                color="#5563D6"
                width="23"
                height="23"
              ></lum-ui-icon>
            </button>
            <button
              mat-button
              type="submit"
              class="lum-button"
              [disabled]="form.invalid"
            >
              Save
              <lum-ui-icon
                class="ml-2-5"
                icon="content-save"
                color="#ffffff"
                width="23"
                height="23"
              ></lum-ui-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
